<template>
  <el-card class="box-card mb-50 box-search">
    <span class="tilte-search mb-10">{{ $t('contacts.index.search_title') }}</span>
    <el-form ref="dataSearch" :model="dataSearch" @submit.prevent="search" class="form-search">
      <el-form-item prop="text" class="keyword">
        <el-input :placeholder="$t('contacts.index.search_input_placeholder_user')" v-model="dataSearch.filters[1].data"/>
      </el-form-item>
      <el-form-item prop="contact_date" class="full-width form-search-date mt-20">
        <label slot="label" class="label-field-search">{{ $t('contacts.index.contact_date') }}</label>
        <date-form
          @change-date="changeDate"
          :date="dataSearch.filters[0].data"
          :key="dataSearch.filters[0].data"
          :yearPlaceHolder="this.$t('year')"
          :listYear="listYear"
        >
        </date-form>
      </el-form-item>
      <div class="mt-25 mb-25">
        <el-button type="danger" class="btn-search" @click="search" @keyup.enter.native="search">{{ $t('btn_search') }}</el-button>
        <el-button type="info" class="btn-clear" @click="resetForm">{{ $t('btn_clear') }}</el-button>
      </div>
    </el-form>
    <table-data
      :data="data"
      :loading="loading"
      :columns="columns"
      :showIndex="false"
      @change-page="handleChangePage"
      @sort="sort">
    </table-data>
  </el-card>
</template>
<script>
  import { getListUserContact } from '../../../api/contact'
  import { convertStatusLabel, convertStatusLabelPartner, convertContentContactToLink } from '../../../common'
  import { YEARS_START_FROM_2022 } from '../../../constants'

  export default {
    props: {
      site: { type: Number, required: false },
    },
    data() {
      return {
        listQuery: {
          page: 1,
          text: "",
          filters: [
            { 'key': 'contact_datetime', 'data': { year: '', month: '', day: '' } },
            { 'key': 'full_name_or_id', 'data': '' },
          ]
        },
        data: {},
        loading: true,
        columns: [
          { prop: "p_id", label: "お問い合わせコード", sortable: "custom", class: "" },
          { prop: "contact_datetime", label: "日付", sortable: "custom", class: "" },
          { prop: "user_name", label: "差出人", sortable: "custom", class: "" },
          { prop: "content", label: "内容", sortable: false,  class: "text-color-primary", labelClass: "text-color-default" },
          { prop: "status", label: "ステータス", sortable: "custom", align: "right" }
        ],
        sortProp: {key: 'updated_at', dir: 'descending'},
        listYear: YEARS_START_FROM_2022,
        dataSearch: {
          page: 1,
          text: "",
          filters: [
            { 'key': 'contact_datetime', 'data': { year: '', month: '', day: '' } },
            { 'key': 'full_name_or_id', 'data': '' },
          ]
        },
      }
    },

    methods: {
      getListData() {
        const query = {...this.listQuery, ...this.sortProp};
        query.filters = JSON.stringify(this.listQuery.filters);

        getListUserContact(query)
          .then(response => response.json())
          .then(response => {
            response.data.records = response.data.records.map(e => {
              return {
                ...e,
                status: (this.site === this.$siteType.site_partner ? convertStatusLabelPartner(e.status, e.status_text) : convertStatusLabel(e.status, e.status_text)),
                content: convertContentContactToLink(e.content, `/contacts/user/${e.id}`)
              }
            });
            this.data = response.data;
            this.loading = false;
          })
          .catch((error) => {})
          .finally(() => {});
      },

      handleChangePage(page) {
        this.loading = true;
        this.listQuery.page = page;
        this.getListData();
      },

      search() {
        this.loading = true;
        this.listQuery = Object.fromEntries(Object.entries(this.dataSearch).map(([k, v]) => [k, v]));
        this.listQuery.page = 1;
        this.getListData();
      },

      sort(sortProps) {
        this.sortProp = {key: sortProps.prop, dir: sortProps.order};
        this.listQuery.page = 1;
        this.getListData();
      },

      resetForm() {
        this.$refs["dataSearch"].resetFields();
        this.dataSearch = {
          page: 1,
          text: "",
          filters: [
            { 'key': 'contact_datetime', 'data': { year: '', month: '', day: '' } },
            { 'key': 'full_name_or_id', 'data': '' },
          ]
        }
      },

      changeDate(data) {
        this.dataSearch.filters[0].data = data;
      },
    },

    created() {
      this.getListData();
    },
  }
</script>
<style lang="scss">
  .keyword {
    width: 450px;
  }
  .el-card__body {
    &>hr {
      margin: 20px 0;
    }
  }
</style>
